module.exports = __webpack_public_path__ + "img/stack01.9b9d20a3.svg";